import React from 'react'
import { Outlet } from 'react-router-dom';

const DashboardOutlet = () => {
  return (
    <Outlet/>
  )
}

export default DashboardOutlet